import type { JumpToDateCalloutContentProps } from "./components/JumpToDateCalloutContent";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailListJumpToLazy"*/ "./lazyIndex"), { name: "MailListJumpToLazy" });

// Delayed Loaded Components
export const LazyJumpToDateCalloutContent: LazyComponent<JumpToDateCalloutContentProps, unknown, void> = createLazyComponent(lazyModule, m => m.JumpToDateCalloutContent);
